import type { SupabaseClient } from "@supabase/supabase-js";
import type { ValidatedBrowserEnvironment } from "./environment-safety";
import type { HostedPortalBackend } from "./hosted-portal-provider";
import type { HostedAyzeoPdfSourceFilePort } from "./hosted-ayzeo-pdf-ingestion";
import { createHostedAyzeoPdfSourceFilePort } from "./hosted-ayzeo-pdf-ingestion";
import { createHostedAyzeoMcpRetrievalPort } from "./hosted-ayzeo-mcp-retrieval";
import { createHostedPdfViewPort } from "./hosted-pdf-viewing";
import type { HostedAyzeoMcpRetrievalPort } from "./hosted-ayzeo-mcp-retrieval";
import type { Database } from "./persistence/database.generated";
import { SupabaseRehearsalPersistenceAdapter } from "./persistence/gateway/supabase-rehearsal-adapter";

export type HostedProductionBootstrap =
  | { kind: "not-requested" }
  | { kind: "stop"; message: string }
  | { kind: "hosted"; provider: "HostedPortalProvider"; backend: HostedPortalBackend; ayzeoPdfSourceFiles: HostedAyzeoPdfSourceFilePort; ayzeoMcpRetrieval: HostedAyzeoMcpRetrievalPort; pdfView:import("./hosted-portal-provider").HostedPdfViewPort };

/** Resolves the only permitted production branch before any Local bootstrap work begins. */
export function resolveHostedProductionBootstrap(input: {
  requested: boolean;
  environment: ValidatedBrowserEnvironment | null;
  configurationError: string | null;
  client: SupabaseClient<Database> | null;
}): HostedProductionBootstrap {
  if (!input.requested) return { kind: "not-requested" };
  if (input.environment?.mode !== "hosted-production") return { kind: "stop", message: input.configurationError ?? "Hosted production configuration is invalid. The portal has not opened." };
  if (!input.client) return { kind: "stop", message: "Hosted production configuration is incomplete. The portal has not opened." };
  return { kind: "hosted", provider: "HostedPortalProvider", backend: new SupabaseRehearsalPersistenceAdapter(input.client), ayzeoPdfSourceFiles: createHostedAyzeoPdfSourceFilePort(input.client), ayzeoMcpRetrieval: createHostedAyzeoMcpRetrievalPort(input.client), pdfView:createHostedPdfViewPort(input.client) };
}
